type Props = {
  storeLabel: string;
  poolValues: { key: string; label: string }[];
  onPick: (poolValue: string) => void;
};

export function PoolValuePicker({ storeLabel, poolValues, onPick }: Props) {
  return (
    <select
      aria-label={`Pool value for ${storeLabel}`}
      value=""
      onChange={(e) => onPick(e.target.value)}
    >
      <option value="">pick another pool value</option>
      {poolValues.map((p) => (
        <option key={p.key} value={p.label}>
          {p.label}
        </option>
      ))}
    </select>
  );
}
